import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReservationEntryType } from 'src/api';
import { CartState } from './state';

export const selectCart = createFeatureSelector<CartState>('cart');

export const selectCartEditingItem = createSelector(selectCart, (cart) => cart.editCartItem);

export const selectCartModel = createSelector(selectCart, (cart) => cart.cart);

export const selectCartItems = createSelector(selectCart, (cart) => cart.cart?.items);

export const selectOrder = createSelector(selectCart, (cart) => cart.order);

export const selectHasCartItems = createSelector(
  selectCart,
  (cart) => cart.cart?.items && cart.cart.items.length > 0,
);

export const selectCartItemCount = createSelector(
  selectCart,
  (cart) =>
    cart.cart?.items.filter(
      (i) =>
        // don't count discount as an item
        i.entryType !== ReservationEntryType.Discount &&
        // don't count recurrence group, except if it's collapsed
        (i.entryType !== ReservationEntryType.RecurrenceGroup || i.collapseRecurrence),
    ).length,
);
